import React, { useMemo } from 'react';
import { useAtomValue } from 'jotai';
import { useStageAtoms } from '../../../labelling-v2/components/stage-scope/hooks';
import useStage from '../../providers/hooks/use-stage';
import type { StageElementT } from '../../types';
import AutoDetectPolygonPreview from '../annotations/rectangle/bounding-box/auto-detect-polygon-preview';
import BoundingBoxActions from '../annotations/rectangle/bounding-box/bounding-box-actions';
export const StageElements = ({
  customElements
}: {
  customElements: ReadonlyArray<StageElementT>;
}) => {
  const {
    getStageDimension
  } = useStage();
  const {
    currentFrameDataAtom,
    currentFrameAnnotationUnderUserReviewAtom
  } = useStageAtoms();
  const annotationUnderUserReview = useAtomValue(currentFrameAnnotationUnderUserReviewAtom);
  const frameData = useAtomValue(currentFrameDataAtom);
  const hasAnnotationUnderUserReview = useMemo(() => {
    return Object.keys(annotationUnderUserReview).length !== 0;
  }, [annotationUnderUserReview]);
  const editorDimensions = getStageDimension();
  return <>
      {customElements.map(customElement => {
      return <React.Fragment key={customElement.name}>{customElement.element}</React.Fragment>;
    })}
      {hasAnnotationUnderUserReview && frameData && <BoundingBoxActions frameData={frameData} dimensions={{
      width: editorDimensions[0],
      height: editorDimensions[1]
    }} />}
      {hasAnnotationUnderUserReview && <AutoDetectPolygonPreview />}
    </>;
};